<template>
  <div class="main-container">
    <!-- Author: Siddhartha
      Date: 17/01/2020
    Issue Description: payroll payroll Dashboard children components-->
    <breadcrumb :list="breadcrumbList" />
    <!-- <under-construction></under-construction> -->
    <div class="margintop-32" />
    <tl-header type="h1">Flexi Benefit Plan</tl-header>
    <div class="twoColumnGridDashboard marginbottom-5p">
      <div class="componentName" v-for="(nav, index) in navList" :key="index">
        <div class="c-title" :class="nav.url ? '': 'disabledMode'" @click="navigateToFBP(nav.url)">{{nav.name}}</div>
        <!-- <div class="c-icon"><img src="@/assets/star_normal.svg" /></div> -->
      </div>
    </div>
    <div class="footers">
    <p><span class="inside_footer">Note</span> : In case of employee opted for any regime and declared and claimed FBP reimbursement - No option to change the regime during the financial year</p>
    </div>
  </div>
</template>


<script>
export default {
  props: {},
  components: {},
  data() {
    return {
        navList:[],
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "FBP",
          url: ``
        }
      ],

    };
  },
  mounted(){
       this.navList= [
        {
          name: "FBP Declaration",
          url:`/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/fbpDeclaration`
        },
        {
          name: "Add New Claim",
          url:`/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/addNewClaim`
        },
        {
          name: "Approve/View Approved Claims",
          url:`/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/approveFbpClaims`
        },
         {
          name: "FBP lock",
          url:`/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/fbpLock`
        },
        {
          name: "Process FBP for the Month",
          url:`/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/fbpProcessMonth`
        },
        {
          name: "FBP Reports",
          url:`/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/fbpReportDownload`
        },
        // {
        //   name: "Assign FBP components to bands",
        //   url: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/assign_fbp_components`
        // },
        
        // {
        //   name: "FBP components mapping",
        //   url: ``
        // },
        // {
        //   name: "FBP Rules",
        //   url: ``
        // },
        // {
        //   name: "FBP settings",
        //   url: ``
        // },
        // {
        //   name: "LTA tracking for Block year",
        //   url: ``
        // },
       

        
        // {
//   name: "Settle FBP claims",
        //   url:`/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/settle_fbp_claims`
        // },
        // {
        //   name: "Upload FBP claims",
        // //  url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/fbp_claim`
        //    url:`/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/fbpClaims`
        // },

        // {
        //   name: "Process FBP Configuration",
        //   url:`/dashboard/${this.$route.params.entity_index}/payroll/utilities/pushFbpConfiguration`
        // },
        // {
        //   name: "Process Un-claimed FBP",
        //   url:`/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/fbpProcessUnClaimed`
        // },
      ]
      
  },
  methods: {
      navigateToFBP(url){
         this.$router.push({
        path:url
          });
      },
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
.footers{
  margin-top: 100px;
  font-size: larger;  
  font-weight: 700;
}
.inside_footer{
  font-weight: 500;
  color: red;
  font-weight: 700;

}
</style>
